import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { LoggedOutLayout } from 'containers';
import { Spinner, PrimaryButton, Terms } from 'components';
import { LLTextField } from 'components/FormElements';
import * as styles from './InviteUserOnboarding.scss';
import { ImageUploadSection } from 'components/AdBuilder';
import { finalizeTeamMemberCreation } from 'redux/modules/teamManagement';

var validator = require('validator');

var InviteUserOnboarding = (_dec = connect(function (state) {
  return {
    invite: state.teamManagement.invite,
    image: state.adBuilder && state.adBuilder.adImage && state.adBuilder.adImage[0] ? state.adBuilder.adImage[0].fullyQualifiedUrl : null,
    theme: state.theme
  };
}, {
  finalizeTeamMemberCreation: finalizeTeamMemberCreation
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(InviteUserOnboarding, _Component);

  var _super = _createSuper(InviteUserOnboarding);

  function InviteUserOnboarding(props) {
    var _this;

    _classCallCheck(this, InviteUserOnboarding);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleFirstNameChange", function (e, val) {
      _this.setState({
        form: _objectSpread(_objectSpread({}, _this.state.form), {}, {
          firstName: val
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLastNameChange", function (e, val) {
      _this.setState({
        form: _objectSpread(_objectSpread({}, _this.state.form), {}, {
          lastName: val
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePasswordChange", function (e, val) {
      _this.setState({
        form: _objectSpread(_objectSpread({}, _this.state.form), {}, {
          password: val,
          passwordsMatch: _this.state.form.password && _this.state.form.confirmPassword ? val === _this.state.form.confirmPassword : true
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleConfirmPasswordChange", function (e, val) {
      _this.setState({
        form: _objectSpread(_objectSpread({}, _this.state.form), {}, {
          confirmPassword: val,
          passwordsMatch: _this.state.form.password && _this.state.form.confirmPassword ? val === _this.state.form.password : true
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAvatarChange", function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          imageUrl = _ref2[0];

      _this.setState({
        form: _objectSpread(_objectSpread({}, _this.state.form), {}, {
          avatarImageUrl: imageUrl
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "canSubmit", function () {
      var _this$state$form = _this.state.form,
          firstName = _this$state$form.firstName,
          lastName = _this$state$form.lastName,
          password = _this$state$form.password,
          confirmPassword = _this$state$form.confirmPassword;

      if (_this.state.isSubmitting) {
        return false;
      }

      if (!firstName || !lastName || !password || !confirmPassword) {
        return false;
      }

      if (password !== confirmPassword) {
        return false;
      }

      if (!password.length || !confirmPassword.length) {
        return false;
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      _this.setState({
        isSubmitting: true
      });

      var payload = _objectSpread(_objectSpread({}, _this.state.form), {}, {
        passwordsMatch: undefined
      });

      _this.props.finalizeTeamMemberCreation(payload, _this.props.invite.organization.id).then(function () {
        _this.setState({
          isSubmitting: false
        });

        window.location.href = '/';
      })["catch"](function (err) {
        _this.setState({
          isSubmitting: false
        });
      });
    });

    _this.state = {
      form: {
        firstName: props.invite.user.firstName,
        lastName: props.invite.user.lastName,
        password: '',
        confirmPassword: '',
        passwordsMatch: true,
        avatarImageUrl: props.image
      },
      termsAccepted: false
    };
    return _this;
  }

  _createClass(InviteUserOnboarding, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$invite = this.props.invite,
          user = _this$props$invite.user,
          organization = _this$props$invite.organization; // the parentOrganizationId === 0 bit is meant to have partner clients skip the T&C step

      if (!this.state.termsAccepted && organization.parentOrganizationId === 0) {
        return /*#__PURE__*/React.createElement(LoggedOutLayout, {
          showNavBar: true
        }, /*#__PURE__*/React.createElement(Helmet, {
          title: "Welcome!"
        }), /*#__PURE__*/React.createElement("div", {
          className: "container",
          style: {
            paddingBottom: 150
          }
        }, /*#__PURE__*/React.createElement(Terms, null), /*#__PURE__*/React.createElement("div", {
          className: "container",
          style: {
            position: 'fixed',
            left: 0,
            bottom: 0,
            width: '100vw',
            height: 100,
            background: 'white',
            boxShadow: '0 -5px 3px rgba(0, 0, 0, 0.11)'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xs-6 col-xs-offset-3"
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xs-6"
        }, /*#__PURE__*/React.createElement("p", null, "By choosing \"I Agree\", you understand and agree to these Terms of Service and our", ' ', /*#__PURE__*/React.createElement("a", {
          href: "/privacy",
          target: "_blank",
          rel: "noopener"
        }, "Privacy Policy"))), /*#__PURE__*/React.createElement("div", {
          className: "col-xs-6"
        }, /*#__PURE__*/React.createElement(PrimaryButton, {
          style: {
            marginTop: 20
          },
          label: "I Agree",
          onClick: function onClick() {
            return _this2.setState({
              termsAccepted: true
            });
          }
        }))))))));
      }

      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showNavBar: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Welcome!"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 ".concat(styles.formWrap)
      }, /*#__PURE__*/React.createElement("h1", {
        className: styles.header,
        style: {
          color: this.props.theme.colors.primaryColor
        }
      }, "Join ", organization.name), /*#__PURE__*/React.createElement("p", {
        className: styles.subheader
      }, "Fill out the fields below and click next."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, "Name"), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        onChange: this.handleFirstNameChange,
        value: this.state.form.firstName,
        fullWidth: true,
        hintText: "First name *"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        onChange: this.handleLastNameChange,
        value: this.state.form.lastName,
        fullWidth: true,
        hintText: "Last name *"
      }))), /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, "Password"), !this.state.form.passwordsMatch ? /*#__PURE__*/React.createElement("p", {
        className: styles.errorText
      }, "Passwords do not match.") : null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        onChange: this.handlePasswordChange,
        value: this.state.form.password,
        fullWidth: true,
        hintText: "Password *",
        type: "password"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        onChange: this.handleConfirmPasswordChange,
        value: this.state.form.confirmPassword,
        fullWidth: true,
        hintText: "Confirm password *",
        type: "password"
      }))), /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, "Avatar"), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(ImageUploadSection, {
        onChange: this.handleAvatarChange
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3 col-xs-offset-9"
      }, /*#__PURE__*/React.createElement(PrimaryButton, {
        label: "Next",
        disabled: !this.canSubmit(),
        onClick: this.handleSubmit
      })))))));
    }
  }]);

  return InviteUserOnboarding;
}(Component), _defineProperty(_class2, "propTypes", {}), _temp)) || _class);
export { InviteUserOnboarding as default };